export default function NotFound() {
  return (
    <div className="text-center h-[100vh] flex align-center flex-col justify-center">
      <h1>404 – Page Not Found</h1>
      <p>The page you are looking for doesn’t exist.</p>
    </div>
  );
}
